<template>
    <div id="add-client" class="add modal inmodal" role="dialog"
         aria-hidden="true" data-backdrop="static" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content animated fadeInUp">
                <div class="modal-header-dialog-painting">
                    <h2 class="modal-title add">{{ t_new }}</h2>
                </div>
                <div class="modal-body">
                    <form class="add-client" role="form" @submit.prevent="step==1 ? check_pairing() : add()">
                        <div class="edit-client-notifications modal-errors">
                            <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
                                {{ t_add_fail }}
                                <ul>
                                    <li v-for="error in errors">
                                        {{ error }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="row m-b">
                            <div class="col-md-12" v-if="step===1">
                                <div :class="[(typeof errors['pairing'] !== 'undefined' ? 'has-error':''),'form-group']">
                                    <label aria-label="pairing input">{{ t_pairing }}
                                        <input type="text" name="pairing" :title="t_pairing" ref="input" required
                                               class="form-control" v-model="pairing">
                                    </label>
                                </div>
                            </div>

                            <div class="col-md-12" v-if="step===2">
                                <div :class="[(typeof errors['name'] !== 'undefined' ? 'has-error':''),'form-group']">
                                    <label aria-label="name input">{{ t_name }}
                                        <input type="text" name="name" :title="t_name" required ref="name"
                                               class="form-control" v-model="screen_name">
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="row m-b" v-if="step===2">
                            <div class="col-md-12">
                                {{ t_screen_id }}: {{ screen_id }}
                            </div>
                        </div>
                        <div class="row m-b" v-if="step===2">
                            <div class="col-md-12">
                                {{ screen_info }}
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <v-btn type="button" :class="[saving ? 'disabled' : '', 'btn btn-primary']" @click.stop.prevent="formNext()">
                        <i class="fa-regular fa-spinner fa-spin-pulse m-r-sm" :class="[saving === true ? '' : 'hidden']"></i>
                        {{ step===2 ? t_add : t_next }}
                    </v-btn>
                    <v-btn type="button" :class="[saving ? 'disabled' : '', 'btn btn-secondary']" @click.stop="cancel()">
                        {{ t_close }}
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import modalMixin from "../../common/modal-mixin";

const MODAL_NAME = 'add-client';

export default {
    mixins: [
        modalMixin
    ],
    components: {
        text255: require('../dynamic_fields/text255.vue').default,
        float: require('../dynamic_fields/float.vue').default,
        bool: require('../dynamic_fields/bool.vue').default,
        date: require('../dynamic_fields/date.vue').default,
        fileupload: require('../dynamic_fields/fileupload.vue').default,
        SwitchOffTimes: require('../../common/switch-off-times').default
    },
    data() {
        return {
            t_close: Lang.langGet("Close"),
            t_new: Lang.langGet("Add new HTML5 client"),
            t_edit: Lang.langGet("Edit client"),
            t_add_fail: Lang.langGet("Failed to add client:"),
            t_add: Lang.langGet("Add"),
            t_next: Lang.langGet("Next"),
            t_pairing: Lang.langGet("Pairing code or screen ID"),
            t_screen_id: Lang.langGet("Screen ID"),
            t_name: Lang.langGet("Name"),

            pairing: '',
            screen_id: '',
            screen_info: '',
            screen_name: '',

            errors: {},
            saving: false,
            step: 1,
        }
    },
    mounted() {
        $(this.$el).on('hidden.bs.modal', () => {
            this.reset();
        });

        EaseEventBus.listen('clientAdd', () => {
            EaseEventBus.fire('showModal', MODAL_NAME);
            this.$nextTick(function () {
                this.$refs.input.focus()
            })
        });
    },
    methods: {
        formNext: function () {
            this.step==1 ? this.check_pairing() : this.add();
        },
        reset: function () {
            _.extend(this.$data, this.$options.data());
        },
        check_pairing: function () {
            this.saving=true;
            axios.post('/administration/client/add/pairing', {
                pairing: this.pairing,
                project_id: Laravel.activeProject
            }).then((data) => {
                if (data.data.screen_id) {
                    this.errors = {};
                    this.step = 2;
                    this.screen_id = data.data.screen_id;
                    this.screen_info = data.data.screen_info;
                    this.saving = false;
                    this.$nextTick(() => {
                        this.$refs.name.focus();
                    })
                } else {
                    this.errors = {
                        'pairing': Lang.langGet("The provided pairing code is invalid.")
                    };
                    this.saving = false;
                }
            }).catch((error) => {
                this.saving = false;

                if (error.response.status === 401) {
                    window.location = '/login';
                } else if (error.response.status === 422) {
                    let tmpErrors = {};

                    for (let key in error.response.data.errors) {
                        tmpErrors[key] = error.response.data.errors[key][0];
                    }
                    this.errors = _.extend({}, tmpErrors);
                } else {
                    this.errors = _.extend({}, {'general': Lang.langGet("Failed to add client to database.")});
                }
            });
        },
        add: function () {
            this.saving=true;
            axios.post('/administration/client/add', {
                screen_id: this.screen_id,
                screen_info: this.screen_info,
                screen_name: this.screen_name,
                project_id: Laravel.activeProject
            }).then((data) => {
                $('#client-table').DataTable().draw();
                this.$nextTick(() => {
                    EaseEventBus.fire('clientEdit', data.data.client_id);
                    EaseEventBus.fire('hideModal', MODAL_NAME);
                })
            }).catch((error) => {
                this.saving = false;

                if (error.response.status === 401) {
                    window.location = '/login';
                } else if (error.response.status === 422) {
                    let tmpErrors = {};

                    for (let key in error.response.data.errors) {
                        tmpErrors[key] = error.response.data.errors[key][0];
                    }
                    this.errors = _.extend({}, tmpErrors);
                } else {
                    this.errors = _.extend({}, {'general': Lang.langGet("Failed to add client to database.")});
                }
            });
        },
        cancel: function () {
            EaseEventBus.fire('hideModal', MODAL_NAME);
        }
    }
}
</script>
